export const EXTENSION_ICON_SIZES: { [size: string]: string } = {
  'extraSmall': 'w-4 h-4',
  'small': 'w-6 h-6',
  'medium': 'w-8 h-8',
  'large': 'w-12 h-12',
}